export default {
  INTERNAL_USER: "InternalUser",
  EXTERNAL_USER: "ExternalUser",
  MANAGER_USER: "ManagerUser",
  INTERNAL_DEFAULT_TYPE: "internalUserDefaultAccount"
};
